<template>
    <nav>
        <v-toolbar hidden-sm-and-down fixed :flat="!smallLogo" app :color="color" class="pr-0" dense :dark="dark">
            <v-toolbar-title></v-toolbar-title>
            <v-toolbar-side-icon v-show="smallLogo" class="hidden-xs-only" @click="scrollToTop">
                <img class="min-logo" alt="CS logo" src="../assets/cs_logo.png"/>
            </v-toolbar-side-icon>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <!--        <v-btn large class="hidden-xs-only nav-btn" flat :to="`/${$i18n.locale}`">{{ $t('navbar.home') }}</v-btn>-->
                <v-btn
                        large
                        class="hidden-xs-only nav-btn"
                        flat
                        :to="`/${$i18n.locale}/about`"
                >{{ $t("navbar.about") }}
                </v-btn
                >
                <v-btn
                        large
                        class="hidden-xs-only nav-btn"
                        flat
                        :to="`/${$i18n.locale}/contact`"
                >{{ $t("navbar.contact") }}
                </v-btn
                >
                <LanguageSwitcher class="nav-btn"/>
                <v-toolbar-side-icon
                        large
                        class="hidden-sm-and-up"
                        @click="drawer = !drawer"
                ></v-toolbar-side-icon>
            </v-toolbar-items>
        </v-toolbar>
        <v-navigation-drawer
                temporary
                right
                dark
                v-model="drawer"
                app
                width="150"
                class="secondary lighten-4"
        >
            <!--      <v-list class="pa-0">-->
            <!--        <v-list-tile :to="`/${$i18n.locale}/`">-->
            <!--          <v-list-tile-action>-->
            <!--            <v-icon>fas fa-home</v-icon>-->
            <!--          </v-list-tile-action>-->
            <!--          <v-list-tile-content>-->
            <!--            <v-list-tile-title>{{ $t('navbar.home') }}</v-list-tile-title>-->
            <!--          </v-list-tile-content>-->
            <!--        </v-list-tile>-->
            <!--      </v-list>-->
            <v-list class="pa-0">
                <v-list-tile :to="`/${$i18n.locale}/about`">
                    <v-list-tile-action>
                        <v-icon>fas fa-address-card</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ $t("navbar.about") }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-list class="pa-0">
                <v-list-tile :to="`/${$i18n.locale}/contact`">
                    <v-list-tile-action>
                        <v-icon>fas fa-envelope</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ $t("navbar.contact") }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-list>
            <img alt="QR code" src="../assets/qr.jpg" height="130rem"/>
            </v-list>
        </v-navigation-drawer>
    </nav>
</template>

<script>
    import LanguageSwitcher from "./LanguageSwitcher";

    export default {
        name: "Navbar",
        components: {LanguageSwitcher},
        data() {
            return {
                drawer: false
            };
        },
        props: {color: String, dark: Boolean, smallLogo: Boolean},
        methods: {
            scrollToTop() {
                this.$vuetify.goTo(0, {
                    duration: 300,
                    offset: 0,
                    easing: "easeOutCubic"
                });
                this.$router.push(`/${this.$i18n.locale}`);
            }
        }
    };
</script>

<style lang="scss">
    .min-logo {
        width: 100%;
        border-radius: 50px;
        /*box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.5);*/
        /*background-color: var(--primary);*/
    }

    .v-btn::before {
        color: transparent;
    }

    .nav-btn.v-btn--active {
        border-bottom-style: solid;
        border-bottom-width: 2px;
        border-bottom-color: var(--secondary)
    }
</style>
